import MiniGameScene from "./MiniGameScene";
import TapOutComponent from "../../components/ncsc/TapOutComponent";

import TapAtlasTexture from "../../../assets/atlas/tapOutGame.png";
import TapAtlasData from "../../../assets/atlas/tapOutGame.json";

import { PHShape } from "../../plugins/global/PlaceholderPlugin";
import CountDown from "../../components/ncsc/CountDown";

export default class TapOutScene extends MiniGameScene {
  private securedTotal: number;
  private updateButton: Phaser.GameObjects.Image;
  private waveNum: number;
  private playedBefore: boolean;

  // private effects: boolean;

  private tapItemGroup: Phaser.GameObjects.Group;
  constructor() {
    super({
      key: "TapOutScene",
      active: false,
    });
    console.log("TapOutScene::constructor");
  }

  preload(): void {
    //
    super.preload();
    // this.cameras.main.setBackgroundColor(0x2b2a7d);
    this.sponge.placeholder.image(
      this,
      this.cameras.main.centerX,
      this.cameras.main.centerY+80,
      PHShape.RECT,
      {
        width: this.cameras.main.width,
        height: this.cameras.main.height-160,
        radius: 0,
      },
      0x2b2a7d
    );

    this.load.atlas("tap-out-atlas", TapAtlasTexture, TapAtlasData);
  }

  create(): void {
    super.create();
    console.log("TapOutScene::create");
    this.securedTotal = 0;
    this.waveNum = 0;
    this.playedBefore = this.sponge.data.save.playedTapOut;

    this.add
      .image(360, 70, "tap-out-atlas", "tap-out-title.png")
      .setOrigin(0.5, 0);
    // .setScale(1.75);

    this.tapItemGroup = this.add.group();
    for (let i: number = 0; i < 9; i++) {
      const tapSprite = new TapOutComponent(this, 0, 0, 1);
      this.tapItemGroup.add(tapSprite);
      tapSprite.on("tapOutReachedBottom", this.failedMiniGame, this);
      tapSprite.on("tapOutItemSecure", this.securedItem, this);
    }

    Phaser.Actions.GridAlign(this.tapItemGroup.getChildren(), {
      width: 3,
      height: 3,
      cellWidth: 200,
      cellHeight: 300,
      x: 260,
      y: 700,
    });

    this.updateButton = this.add.image(
      380,
      1220,
      "tap-out-atlas",
      "auto-update-off.png"
    );

    this.updateButton.alpha = 0.2;

    if(this.playedBefore){this.activateUpdateButton();}
  }

  start() {
    super.start();
    //called when we can start running the mini game

    const cd = new CountDown(this);
    cd.on("countdown-complete",this.resumeAllActions, this)
    cd.startCountDown();

    this.tapItemGroup.children.iterate((go: TapOutComponent) => {
      go.initProgress();
      go.pauseRundown();
    });


    console.log("TAPOUT START FUNCTION CALLED")
  }

  pauseAllActions(){
    console.log("pause minigame sprites:TapOut")
    this.tapItemGroup.children.each(function (child: TapOutComponent) {
      child.pauseRundown();
    }, this);
  }

  resumeAllActions(){
    console.log("resume minigame sprites:TapOut")
    this.tapItemGroup.children.each(function (child: TapOutComponent) {
      child.startRundown();
    }, this);

    super.resumeAllActions();
  }

  failedMiniGame() {
    this.tapItemGroup.children.each(function (child: TapOutComponent) {
      child.pauseRundown();
    }, this);

    
    this.time.addEvent({
      delay: 2000,
      callbackScope: this,
      callback: () => {
        if (this.waveNum === 0 && !this.playedBefore) {
          this.waveNum++;
          this.activateUpdateButton();
          this.securedTotal = 0;
          // show mid game popup

          this.sponge.popup.launchPopup("update-TapOutScene-negative",()=>{
            this.initDevices();
          })
          this.sponge.popup.updateCloseLabel(this.sponge.data.content.strings.retry)
    
        } else {
        this.complete(0);
        this.shutdown();
        }
      }
    });
    

    
  }

  securedItem() {
    this.securedTotal++;

    if (this.securedTotal === this.tapItemGroup.getLength()) {
      this.time.addEvent({
        delay: 2000,
        callbackScope: this,
        callback: this.checkMiniGameComplete,
      });
    }
  }

  checkMiniGameComplete() {
    if (this.waveNum === 0 && !this.playedBefore) {
      this.waveNum++;
      this.activateUpdateButton();
      this.securedTotal = 0;
      // show mid game popup
      this.sponge.popup.launchPopup("update-TapOutScene-positive",()=>{
        this.initDevices();
      })

      this.sponge.popup.updateCloseLabel(this.sponge.data.content.strings.retry)

    } else {
      this.complete(1);
      this.shutdown();
    }
  }

  initDevices() {
    this.tapItemGroup.children.each(function (child: TapOutComponent) {
      child.initProgress();
    }, this);
  }

  activateUpdateButton() {
    this.updateButton.alpha = 1;
    this.updateButton.setInteractive();
    this.updateButton.on("pointerdown", this.autoUpdateActivate, this);
    if(!this.playedBefore){
      this.sponge.data.save.playedTapOut = true;
      this.sponge.tracking.save()
    }
    
  }

  autoUpdateActivate() {
    this.updateButton.setTexture("tap-out-atlas", "auto-update-on.png");
    this.updateButton.disableInteractive();
    this.tapItemGroup.children.each(function (child: TapOutComponent) {
      child.setRundownParameters(0.75, true);
    }, this);
  }

  update(time: number, delta: number): void {
    //
  }

  shutdown(): void {
    //call our minigame complete method
    super.shutdown();
  }
}
